
import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalPinCodeRecovery.scss';
import {
    Grid,
    Row,
    cls,
    Column,
    Button
} from '../../packages/components';
import Translator from '../../requests/apa/Translator';
const MAIN_CLASSNAME = 'aaf-modal-pin-code-recovery';

const ModalPinCodeRecovery = ({ email ='', handleClose = () => {} }) => {
    const modalProps = {
        childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
    };

    const handleClick = () => {
        handleClose();
    }


    const lowerEmail =(email && email.toLocaleLowerCase && email.toLocaleLowerCase()) || '';

    return (
        <ModalWrapper {...modalProps}>
            <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={4}/>
                    <Column lg={4} className={cls(`${MAIN_CLASSNAME}-title`)}>
                        { Translator.get('modal_pin_recovery_title', 'Revisá tu bandeja de entrada o tu correo no deseado') }
                    </Column>
                    <Column lg={4}/>
                </Row>
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={4}/>
                    <Column lg={4} className={cls(`${MAIN_CLASSNAME}-subtitle`)}>
                        { Translator.get('modal_pin_recovery_subtitle', 'Enviamos tu PIN de seguridad al correo @email').replace('@email', lowerEmail) }
                    </Column>
                    <Column lg={4}/>
                </Row>
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={'1-5'}/>
                    <Column lg={2}/>
                    <Column lg={5} className={cls(`${MAIN_CLASSNAME}-button`)}>
                        <Button
                            type="button"
                            variant="primary"
                            className={cls(`focusable`)}
                            onClick={handleClick}
                            block
                        >
                            { Translator.get('modal_pin_recovery_button','ENTENDIDO') }
                        </Button>
                    </Column>
                    <Column lg={2}/>
                    <Column lg={'1-5'}/>
                </Row>
            </Grid>
        </ModalWrapper>
    );
}

export default withOnClose(ModalPinCodeRecovery);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPinCodeRecovery.jsx